import { render, staticRenderFns } from "./soundImage.vue?vue&type=template&id=7f6aee4a&scoped=true"
import script from "./soundImage.vue?vue&type=script&lang=js"
export * from "./soundImage.vue?vue&type=script&lang=js"
import style0 from "./soundImage.vue?vue&type=style&index=0&id=7f6aee4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6aee4a",
  null
  
)

export default component.exports